import { defineComponent as _defineComponent } from 'vue';
import { BOverlay, BRow, BCol } from 'bootstrap-vue';
import FrameDesignOption from 'public/components/picture-frames/Value/FrameDesignOption.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { useAxios } from 'composables/useAxios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FrameDesignSelector',
    props: {
        value: null,
        groupId: null,
        itemSize: null,
        lengthSku: null,
        mount: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedFrameSize = computed({
            get: () => props.value,
            set: v => emit('input', v)
        });
        const loading = ref(true);
        const frameSizes = ref([]);
        const noMountPrice = ref('0.00');
        const isItemSizeValidFrame = computed(() => props.itemSize.width >= 100 && props.itemSize.length >= 100);
        const axios = useAxios();
        const getFrameSizes = async () => {
            loading.value = true;
            const requests = [];
            if (isItemSizeValidFrame.value) {
                requests.push(axios
                    .get('valueFrames/noFramePrice', {
                    params: {
                        groupID: props.groupId,
                        itemWidth: props.itemSize.width,
                        itemLength: props.itemSize.length,
                        lengthSku: props.lengthSku
                    }
                })
                    .then(({ data }) => (noMountPrice.value = data.price)));
            }
            requests.push(axios
                .get('valueFrames/frameSizes', {
                params: {
                    groupID: props.groupId,
                    itemWidth: props.itemSize.width,
                    itemLength: props.itemSize.length,
                    lengthSku: props.lengthSku,
                    mountSku: props.mount.stock_lookup_sku
                }
            })
                .then(({ data }) => (frameSizes.value = data.map(size => ({
                type: size.type,
                name: size.name,
                width: size.width_mm,
                length: size.height_mm,
                price: size.price
            })))));
            await Promise.all(requests);
            if (isItemSizeValidFrame.value) {
                selectSize(props.itemSize);
            }
            else {
                selectSize(frameSizes.value[0]);
            }
            loading.value = false;
        };
        const selectSize = (size) => emit('input', size);
        watch(() => [props.itemSize, props.mount.stock_lookup_sku], () => getFrameSizes(), { deep: true });
        onMounted(() => { getFrameSizes(); });
        return { __sfc: true, props, emit, selectedFrameSize, loading, frameSizes, noMountPrice, isItemSizeValidFrame, axios, getFrameSizes, selectSize, BOverlay, BRow, BCol, FrameDesignOption, computed, onMounted, ref, watch, useAxios };
    }
});
